import { DonationOutput } from 'gql/types';
import { DonationBaseChart } from 'modules/donor/components';
import { getConfig } from 'modules/donor/components/WeightChart/config';
import { FC } from 'react';

type Props = {
  donationData: DonationOutput[];
};

const WeightChart: FC<Props> = ({ donationData }) => (
  <DonationBaseChart lineConfig={getConfig(donationData)} />
);

export default WeightChart;
